export default __webpack_public_path__ + "static/media/photo--lg--67.a174cff7.jpg";